import {showPopUp} from "components/PopUp";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import RankingBoard from "../JumpScene2/RankingBoard";
import {createPlayRank, updatePlayRank, getPlayRank} from "api-v3";
import View from "./View";

export default function Container({textSet, leftButtonText, rightButtonText, leftHandler, rightHandler, dismiss}) {
  const [popupText, setPopupText] = useState([""]);
  const [leftBtnText, setLeftBtnText] = useState("");
  const [rightBtnText, setRightBtnText] = useState("");
  const gameState = useSelector(state => state.game);
  const {id} = useSelector(state => state.userinfo);

  useEffect(() => {
    if (gameState.messageFromGame?.record) {
      const updateRecord = async record => {
        try {
          getPlayRank({worldType: "JUMP"}).then(body => {
            if (body.code === 0) {
              let tag = "DEFAULT";
              createPlayRank({best: record, worldType: "JUMP", eventType: "DEFAULT", tag: tag});
            } else if (body.data.best === null || body.data.best > record) {
              updatePlayRank({worldType: "JUMP", eventType: "DEFAULT"}, {best: record});
            }
          });
        } catch (error) {
          console.log(error);
        }
      };

      updateRecord(gameState.messageFromGame.record);
    }
  }, [gameState.messageFromGame]);

  useEffect(() => {
    if (textSet && textSet.length > 0) {
      setPopupText(textSet);
    }
  }, [textSet]);

  useEffect(() => {
    setLeftBtnText(leftButtonText);
  }, [leftButtonText]);

  useEffect(() => {
    setRightBtnText(rightButtonText);
  }, [rightButtonText]);

  const onClickLeft = () => {
    switch (leftHandler.type) {
      case "redirect":
        window.location.href = `${window.location.protocol}//${window.location.host}/studio/?mode=play&pid=${leftHandler.url}`;
        break;
      case "ranking":
        showPopUp(<RankingBoard isCloseUsable singlePopup />, {
          defaultPadding: false,
          clearOverHidden: true,
          kbPopupSetting: true,
          transparentBackground: true,
        });
        break;
      default:
        break;
    }
    dismiss();
  };

  const onClickRight = () => {
    switch (rightHandler.type) {
      case "redirect":
        window.location.href = `${window.location.protocol}//${window.location.host}/studio/?mode=play&pid=${rightHandler.url}`;
        break;
      default:
        break;
    }
    dismiss();
  };

  const getKSTDateString = () => {
    const date = new Date();

    date.setTime(date.getTime() + 9 * 60 * 60 * 1000);

    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <View textSet={popupText} leftBtnText={leftBtnText} rightBtnText={rightBtnText} onClickLeft={onClickLeft} onClickRight={onClickRight} />
  );
}
